import React from "react";
import { ArrowRight } from "lucide-react";

const PropertyListing = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="w-full bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white p-4 relative">
          <div className="bg-white"></div>
          <h1 className="text-lg sm:text-xl font-semibold">
            Kalinga Nagar, Bhubaneswar
          </h1>
        </div>

        {/* Content */}
        <div className="p-4">
          <h2 className="text-lg sm:text-xl md:text-2xl font-semibold mb-1 sm:mb-2 md:mb-3 lg:mb-4 text-gray-900">
            25+ Properties for Sale
          </h2>

          {/* Property Types */}
          <div className="space-y-4 mb-8">
            <div className="flex items-center justify-between p-4 border-2 border-gray-200 rounded-xl">
              <span className="text-lg sm:text-xl md:text-3xl font-semibold text-red-600">
                2 BHK
              </span>
              <span className="text-sm font-semibold sm:text-base md:text-lg text-gray-600">
                ₹50Lac - ₹80Cr
              </span>
            </div>

            <div className="flex items-center justify-between p-4 border-2 border-gray-200 rounded-xl">
              <span className="text-lg sm:text-xl md:text-3xl font-semibold text-red-600">
                3 BHK
              </span>
              <span className="text-sm font-semibold sm:text-base md:text-lg text-gray-600">
                ₹80Lac - ₹1.3Cr
              </span>
            </div>
          </div>

          {/* Projects Section */}
          <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-1 sm:mb-2 md:mb-3 lg:mb-4 text-gray-900">
            10 Projects
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 lg:gap-6 xl:gap-2 mb-8">
            {/* Under Construction */}
            <div className="border-2 border-gray-200 rounded-md cursor-pointer group px-2 md:px-3 lg:px-4 xl:px-0 lg:py-2 xl:py-0">
              <div className="flex items-center gap-2 p-2">
                <span className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-3xl font-semibold text-red-600">
                  8
                </span>
                <div>
                  {/* <div className="font-normal text-xs text-gray-800">Under</div> */}
                  <div className="flex items-center gap-1 font-medium text-sm md:text-lg lg:text-2xl xl:text-xs text-gray-800">
                    Under Construction{" "}
                    <span>
                      <ArrowRight
                        className="text-red-600 group-hover:translate-x-1 transition-transform"
                        size={24}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Ready to Move */}
            <div className="border-2 border-gray-200 rounded-md cursor-pointer group px-2 md:px-3 lg:px-4 xl:px-0 lg:py-2 xl:py-0">
              <div className="flex items-center gap-2 p-2">
                <span className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-3xl font-semibold text-red-600">
                  2
                </span>
                <div>
                  {/* <div className="font-normal text-xs text-gray-800">Under</div> */}
                  <div className="flex items-center gap-1 font-medium text-sm md:text-lg lg:text-2xl xl:text-xs text-gray-800">
                    Ready to Move{" "}
                    <span>
                      <ArrowRight
                        className="text-red-600 group-hover:translate-x-1 transition-transform"
                        size={24}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Continue Button */}
          <button className="w-full bg-red-600 hover:bg-red-700 text-white text-xl font-semibold py-4 rounded-full transition-colors shadow-lg">
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropertyListing;
